module.exports = __webpack_public_path__ + "static/service-2-023d8760cbae7150be50c2b329b8202f.png";